import { Button, Icon } from "components/ui";
import { useState } from "react";
import Logotype from "components/layout/topbar/Logotype";
import { useApi } from "hooks/api";
import { useAuth } from "hooks/auth";
import { useMutation } from "react-query";
import { OAuthToken } from "types/qbank/token";

export default function Login() {
  const { setAuth } = useAuth();
  const { api, login } = useApi();
  const [logoutReason, setLogoutReason] = useState<string>("");
  const [errors, setErrors] = useState({
    host: false,
    username: false,
    password: false,
  });
  const [host, setHost] = useState(api.host);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const { mutate: loginMutation, isLoading } = useMutation(login, {
    onSuccess: (data: OAuthToken) => {
      setAuth({ isLoggedIn: true, oAuthToken: data });
    },
    onError: (error: any) => {
      setLogoutReason("Could not login with the given credentials");
    },
  });

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (!host.length || !username.length || !password.length) {
      setErrors({
        host: !!host.length,
        username: !!username.length,
        password: !!password.length,
      });
    } else {
      localStorage.setItem("host", host);
      setErrors({
        host: false,
        username: false,
        password: false,
      });
      loginMutation({ host, username, password });
    }
  };

  return (
    <div className="connector-body">
      <div className="login-wrapper">
        <Logotype />
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          {logoutReason && <span className="bad-details">{logoutReason}</span>}

          <div className="input-group">
            <label className="label">Host</label>
            <input
              type="text"
              value={host}
              onChange={(e) => setHost(e.target.value)}
              autoFocus={true}
              required={true}
              className={errors.host ? "error" : ""}
            />
            <Icon name={"home"} />
          </div>

          <div className="input-group striped">
            <label className="label">Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus={!!api.host}
              required={true}
              className={errors.username ? "error" : ""}
            />
            <Icon name={"user"} />
          </div>

          <div className="input-group">
            <label className="label">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required={true}
              className={errors.password ? "error" : ""}
            />
            <Icon name={"lock"} />
          </div>

          <Button
            type="submit"
            loading={isLoading}
            icon={isLoading ? "cog" : "sign-in-alt"}
            disabled={isLoading}
          >
            Login
          </Button>
        </form>
      </div>
    </div>
  );
}
